import React from "react";
import { createPortal } from "react-dom";
import { AccessibilityPopup } from '@skillz/accessibility';
import Icon from "../icons/Icon";
import iconsList from "../icons/iconsList";
import classes from './SimplePopup.module.css';

const SimplePopup = ({
    style,
    dropClass,
    dropClassClose,
    close,
    children,
    dropClassContainer,
    accessibilityDescription,
    anchored = false,
}) => {

    const handleClose = (e) => {
        e && e.stopPropagation();
        close && close();
    };

    if (anchored) {
        return (
            <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={handleClose}>
                <div className={dropClassContainer || ''} role="dialog">
                    {children}
                </div>
            </AccessibilityPopup>
        );
    }

    return createPortal(
        <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={handleClose}>
            <div className={`${classes.BackdropPopupContainer} ${dropClassContainer || ''}`}>
                <div className={`${classes.BackdropPopup} ${dropClass || ''}`} style={style}>
                    {close &&
                        <Icon
                            size={"31px"}
                            name={iconsList.x}
                            color={"black"}
                            className={`${classes.Close} ${dropClassClose || ''}`}
                            onClick={handleClose}
                        />
                    }
                    <div className={classes.PopupBody}>
                        {children}
                    </div>
                </div>
            </div>
        </AccessibilityPopup>,
        document.body
    );
};

export default SimplePopup;
